import { useEffect } from 'react';
import { useParams } from 'react-router';
import UbicacionForm from '../../components/ubicaciones/UbicacionForm';
import { useUbicacionesStore, type ActualizarUbicacion } from '../../stores/ubicaciones/ubicaciones.store';

const EditarUbicacion = () => {
  const paramId = useParams<{ id: string }>().id ?? '';
  const id = Number(paramId);
  const {
    current: ubicacion,
    actualizar,
    activar,
    desactivar,
    cargarPorId
  } = useUbicacionesStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
  }, [id]);

  const handleSave = async (values: ActualizarUbicacion) => {
    await actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    await activar(id);
  };

  return (
    <UbicacionForm
      ubicacion={ubicacion}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
    />
  );
};

export default EditarUbicacion;
